import React from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

const SaveButtons = ({
  accountId,
  extract_id,
  saveOpen,
  toggleSave,
  save,
  validateReport,
  saveRunOpen,
  toggleSaveRun
}) => {
  const history = useHistory();

  return (
    <ul className={extract_id ? "list-inline dropdown-space" : "list-inline"}>
      <li className="list-inline-item">
        {extract_id ? (
          <ButtonDropdown
            direction="down"
            isOpen={saveOpen}
            toggle={toggleSave}
            disabled={!save}
          >
            <Button
              id="save-SplitButton"
              caret="true"
              color={save ? "primary" : "secondary"}
              outline
              disabled={!save}
              onClick={() => validateReport(false, false)}
            >
              Save
            </Button>
            <DropdownToggle
              split
              color={save ? "primary" : "secondary"}
              outline
              disabled={!save}
            />
            <DropdownMenu>
              <DropdownItem
                id="save-Dropdown"
                onClick={() => validateReport(false, false)}
              >
                Save
              </DropdownItem>
              <DropdownItem
                id="saveAsNew-Dropdown"
                onClick={() => validateReport(false, true)}
              >
                Save As New
              </DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
        ) : (
          <Button
            color={save ? "primary" : "secondary"}
            id="save-Button"
            outline
            disabled={!save}
            onClick={() => validateReport(false, false)}
          >
            Save
          </Button>
        )}
      </li>
      <li className="list-inline-item">
        {extract_id ? (
          <ButtonDropdown
            direction="down"
            isOpen={saveRunOpen}
            toggle={toggleSaveRun}
          >
            <Button
              id="saveAndRun-SplitButton"
              caret="true"
              onClick={() => validateReport(true, false)}
              outline
              color={save ? "primary" : "secondary"}
              disabled={!save}
            >
              Save &amp; Run
            </Button>
            <DropdownToggle
              split
              color={save ? "primary" : "secondary"}
              disabled={!save}
              outline
            />
            <DropdownMenu>
              <DropdownItem
                id="saveAndRun-Dropdown"
                onClick={() => validateReport(true, false)}
              >
                Save &amp; Run
              </DropdownItem>
              <DropdownItem
                id="saveAndRunAsNew-Dropdown"
                onClick={() => validateReport(true, true)}
              >
                Save &amp; Run As New
              </DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
        ) : (
          <Button
            color={save ? "primary" : "secondary"}
            id="saveAndRun-Button"
            outline
            disabled={!save}
            onClick={() => validateReport(true, false)}
          >
            Save &amp; Run
          </Button>
        )}
      </li>
      <li className="list-inline-item">
        <Button
          color="link"
          onClick={() => {
            history.push(`/app/account/${accountId}`);
          }}
        >
          Cancel
        </Button>
      </li>
    </ul>
  );
};

export default SaveButtons;

SaveButtons.propTypes = {
  extract_id: PropTypes.string,
  saveOpen: PropTypes.bool,
  save: PropTypes.bool,
  saveRunOpen: PropTypes.bool,
  validateReport: PropTypes.func.isRequired,
  toggleSave: PropTypes.func.isRequired,
  toggleSaveRun: PropTypes.func.isRequired
};

SaveButtons.defaultProps = {
  extract_id: null,
  saveOpen: false,
  save: false,
  saveRunOpen: false
};
